import { __assign, __rest } from "tslib";
import { Path } from '../shape';
var sin = Math.sin, cos = Math.cos, atan2 = Math.atan2, PI = Math.PI;
function _addDefaultArrow(shape, attrs, x1, y1, x2, y2, isStart) {
    var stroke = attrs.stroke, lineWidth = attrs.lineWidth;
    var x = x1 - x2;
    var y = y1 - y2;
    var rad = atan2(y, x);
    var arrowShape = new Path({
        type: 'path',
        canvas: shape.get('canvas'),
        isArrowShape: true,
        attrs: {
            // é»è®¤ç®­å¤´çè¾¹é¿ä¸º 10ï¼å¤¹è§ä¸º 60 åº¦
            path: "M" + 10 * cos(PI / 6) + "," + 10 * sin(PI / 6) + " L0,0 L" + 10 * cos(PI / 6) + ",-" + 10 * sin(PI / 6),
            // ä½¿ç¨ shape stroke å¼
            stroke: stroke,
            lineWidth: lineWidth,
        },
    });
    arrowShape.translate(x2, y2);
    arrowShape.rotateAtPoint(x2, y2, rad);
    shape.set(isStart ? 'startArrowShape' : 'endArrowShape', arrowShape);
}
/**
 * ç®­å¤´ path çè®¾ç½®è¦æ±
 * 1. ç®­å¤´é¡¶ç¹åæ éè¦ä¸º (0, 0)
 * 2. ç®­å¤´å¤¹è§çä¸­å¿åå²çº¿éè¦ä¸ X è½´æ­£æ¹åå¯¹é½
 */
function _addCustomizedArrow(shape, attrs, x1, y1, x2, y2, isStart) {
    var startArrow = attrs.startArrow, endArrow = attrs.endArrow, stroke = attrs.stroke, lineWidth = attrs.lineWidth;
    var arrowAttrs = isStart ? startArrow : endArrow;
    var d = arrowAttrs.d, arrowFill = arrowAttrs.fill, arrowStroke = arrowAttrs.stroke, arrowLineWidth = arrowAttrs.lineWidth, restAttrs = __rest(arrowAttrs, ["d", "fill", "stroke", "lineWidth"]);
    var x = x1 - x2;
    var y = y1 - y2;
    var rad = atan2(y, x);
    if (d) {
        x2 = x2 - cos(rad) * d;
        y2 = y2 - sin(rad) * d;
    }
    var arrowShape = new Path({
        type: 'path',
        canvas: shape.get('canvas'),
        isArrowShape: true,
        attrs: __assign(__assign({}, restAttrs), { 
            // æ¯æåç¬è®¾ç½®ç®­å¤´ç stroke å lineWidthï¼è¥ä¸ºç©ºåä½¿ç¨ shape çå¼
            stroke: arrowStroke || stroke, lineWidth: arrowLineWidth || lineWidth, 
            // ç®­å¤´æ¯å¦å¡«åéè¦æå¨è®¾ç½®ï¼ä¸ä¼ç»§æ¿èª shape çå¼
            fill: arrowFill }),
    });
    arrowShape.translate(x2, y2);
    arrowShape.rotateAtPoint(x2, y2, rad);
    shape.set(isStart ? 'startArrowShape' : 'endArrowShape', arrowShape);
}
/**
 * å¦æèªå®ä¹ç®­å¤´å¹¶ä¸æ d éè¦ååç§»ï¼å¦æç´æ¥ç»ï¼çº¿æ¡ä¼è¶åºç®­å¤´å°ç«¯ï¼å æ­¤éè¦æ ¹æ®ç®­å¤´åç§» d, è¿åçº¿éè¦ç¼©ç­çè·ç¦»
 * |----------------
 * |<|--------------
 * |
 * @param {number} x1 èµ·å§ç¹ x
 * @param {number} y1 èµ·å§ç¹ y
 * @param {number} x2 ç®­å¤´ä½ç¨ç¹ x
 * @param {number} y2 ç®­å¤´ä½ç¨ç¹ y
 * @param {number} d  ç®­å¤´æ²¿çº¿æ¡æ¹åçåç§»è·ç¦»
 * @return {{dx: number, dy: number}} è¿åçº¿æ¡åç§»è·ç¦»
 */
export function getShortenOffset(x1, y1, x2, y2, d) {
    var rad = atan2(y2 - y1, x2 - x1);
    return {
        dx: cos(rad) * d,
        dy: sin(rad) * d,
    };
}
/**
 * ç»å¶èµ·å§ç®­å¤´
 * @param {IShape} shape å¾å½¢
 * @param {ShapeAttrs} attrs shape çç»å¾å±æ§
 * @param {number} x1 èµ·å§ç¹ x
 * @param {number} y1 èµ·å§ç¹ y
 * @param {number} x2 ç®­å¤´ä½ç¨ç¹ x
 * @param {number} y2 ç®­å¤´ä½ç¨ç¹ y
 */
export function addStartArrow(shape, attrs, x1, y1, x2, y2) {
    if (typeof attrs.startArrow === 'object') {
        _addCustomizedArrow(shape, attrs, x1, y1, x2, y2, true);
    }
    else if (attrs.startArrow) {
        _addDefaultArrow(shape, attrs, x1, y1, x2, y2, true);
    }
    else {
        shape.set('startArrowShape', null);
    }
}
/**
 * ç»å¶ç»æç®­å¤´
 * @param {IShape} shape å¾å½¢
 * @param {ShapeAttrs} attrs shape çç»å¾å±æ§
 * @param {number} x1 èµ·å§ç¹ x
 * @param {number} y1 èµ·å§ç¹ y
 * @param {number} x2 ç®­å¤´ä½ç¨ç¹ x
 * @param {number} y2 ç®­å¤´ä½ç¨ç¹ y
 */
export function addEndArrow(shape, attrs, x1, y1, x2, y2) {
    if (typeof attrs.endArrow === 'object') {
        _addCustomizedArrow(shape, attrs, x1, y1, x2, y2, false);
    }
    else if (attrs.endArrow) {
        _addDefaultArrow(shape, attrs, x1, y1, x2, y2, false);
    }
    else {
        shape.set('startArrowShape', null);
    }
}
//# sourceMappingURL=arrow.js.map